import { useQuery } from "@tanstack/react-query"

import { EMPLOYEE_QUERY_KEY, ROLE_QUERY_KEY } from "@/constants/query"
import { getEmployeeById, getEmployeeRoles, getEmployees } from "@/http/employee"

import { IRequestParams } from "@/types/api"

export const useEmployeesQuery = (params?: IRequestParams) => {
  return useQuery({
    queryFn: () => getEmployees(params ?? {}),
    queryKey: [EMPLOYEE_QUERY_KEY, params],
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  })
}

export const useEmployeeByIdQuery = (id: string) => {
  return useQuery({
    queryFn: () => getEmployeeById(id),
    queryKey: [EMPLOYEE_QUERY_KEY, id],
    enabled: !!id,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  })
}

export const useEmployeeRolesQuery = () => {
  return useQuery({
    queryFn: () => getEmployeeRoles(),
    queryKey: [EMPLOYEE_QUERY_KEY, "employee-roles"],
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  })
}
